export default function maskEmail(email?: string) {
  if (!email) return ''

  const [name = '', domain = ''] = email.split('@')
  const firstLetter = name[0]
  const lastLetter = name[name.length - 1]

  return `${firstLetter}...${lastLetter}@${domain}`
}
